import { msalInstance } from "../Auth/AuthConfig";
var tokenKeySherlock = "SherlockAppToken";
var tokenKeyMicro = "MicroAppToken";
export var fetchTokenFromLocalStorage = function () {
    try {
        var token = localStorage.getItem(tokenKeySherlock);
        if (token !== null) {
            return token;
        }
        else {
            var tokenMicro = localStorage.getItem(tokenKeyMicro);
            return tokenMicro !== null ? tokenMicro : "";
        }
    }
    catch (error) {
        console.log(error);
        return null;
    }
};
export var logout = function () {
    var allAccounts = msalInstance.getAllAccounts();
    if (allAccounts.length > 0) {
        var myAccount = allAccounts[0];
        msalInstance
            .logout({
            account: myAccount,
            postLogoutRedirectUri: "/",
        })
            .then(function () {
            console.log("Logout successful.");
        })
            .catch(function (error) {
            console.error("Logout error:", error);
        });
    }
    else {
        msalInstance.logout();
    }
};
